import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, GoogleMapsApiSelectors } from 'app/store';
import { Observable, Subject, filter } from 'rxjs';

@Component({
  template: '',
})
export class SearchAutocompleteComponent implements AfterViewInit, OnDestroy {
  // Handle AutoComplete
  // search address <input> html element
  @ViewChild('searchAddressInput') public searchElementRef!: ElementRef;

  // Google Maps Autocomplete Options
  options = {
    componentRestrictions: { country: 'us' },
    fields: ['address_components', 'geometry', 'icon', 'name'],
    strictBounds: false,
  };

  public apiLoaded$: Observable<boolean>;
  private destroyed$ = new Subject<boolean>();

  constructor(store$: Store<AppState>) {
    this.apiLoaded$ = store$.select(
      GoogleMapsApiSelectors.selectGoogleMapsApiLoaded,
    );
  }

  // autocomplete address search
  ngAfterViewInit(): void {
    this.apiLoaded$.pipe(filter((apiLoaded) => apiLoaded)).subscribe(() => {
      new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        this.options,
      );
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
